export default {
  en: {
    base: {
      appLoginName: 'Login Name',
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
      passwordSetSuccess: 'Password successfully set',
      passwordSetError: 'The code does not exist or has already been used',
      password: 'Password',
      clock: 'o\'clock',
      cancel: 'Cancel',
      delete: 'Delete',
      create: 'Create',
      ok: 'Ok',
      close: 'Close',
      save: 'Save',
      continue: 'Continue',
      finish: 'Finish',
      start: 'Start',
      hours: 'hours',
      minutes: 'minutes',
      seconds: 'seconds',
      amount: 'Amount',
      percentage: 'Percentage',
      time: 'Time',
      note: 'Note',
      customer: 'Customer',
      loading: 'Loading...',
      to: 'to',
      updates: 'Descriptions and Updates',
      error_solved: 'Error resolved'
    },
    login: {
      login_action: 'Login',
      registration_heading: 'Login',
      registration_text: 'Please enter your user credentials',
      username_placeholder: 'Enter username',
      password_placeholder: 'Enter password',
      username_label: 'Username',
      password_label: 'Password',
      username_required: 'Username is required!',
      password_required: 'Password is required!',
      failed_login_attempts: 'Login is blocked due to failed login attempts',
      continue: 'Continue',
      back: 'Back',
      microsoft_login: 'Sign in with Microsoft',
      identify_error: 'The user could not be identified',
      entra_login_error: 'Signing in with Microsoft failed',
    },
    password: {
      title: 'Success',
      error: 'Error',
      heading: 'Set New Password',
      text: 'Here you can set up your personal password for the experts4media ServiceApp. The password must be at least 8 characters long. And it must contain at least three of the following four elements: a digit, an uppercase letter, a lowercase letter, a special character.',
      password_doesnt_match_guidelines: 'The password does not meet the criteria',
      password: 'Password',
      passwordRepeat: 'Repeat password',
      save_password: 'Save password',
      check_password: 'The passwords do not match',
      finished: 'The password was successfully saved. Please log in to the app.'
    },
    main: {
      logout: 'Logout'
    },
    nav: {
      current_reports: 'Current Reports',
      new_report: 'Create New Report',
      report_categories: 'Report Categories',
      customer_settings: 'Customer Settings',
      server_settings: 'Server Settings',
      tenant_management: 'Tenant Management',
      global_overview: 'Global Overview'
    },
    current_reports: {
      select_tenant: 'Select Tenant',
      select_tenant_info: 'Please select a tenant',
      select_tenant_description: 'To view reports, please first select a tenant from the list.',
      tenant_load_error: 'Error loading tenants',
      report_created: 'Report created',
      report_last_updated: 'Last update',
      report_creator: 'Creator',
      report_updater: 'Updater',
      report_done_dialog_title: 'Completion report',
      report_done_dialog_help: 'Please enter a completion report:',
      report_extend_time_range_dialog_title: 'Reason for extension',
      report_extend_time_range_dialog_help: 'Please enter the reason for the extension:',
      report_extend_time_range_default_reason: 'The necessary maintenance work is taking longer than expected. experts4media is therefore extending this measure.',
      report_extend_time_range_readonly_hint: 'The start time cannot be changed because maintenance is already active'
    },
    report: {
      select_tenant: 'Select Tenant',
      tenant_load_error: 'Error loading tenants',
      customer_load_error: 'Error loading customers',
      tenant_required: 'Please select a tenant',
      category_load_error: 'Error loading categories'
    },
    report_categories: {
      title: 'Report Categories',
      name: 'Name',
      type: 'Type',
      level: 'Level',
      color: 'Color',
      priority: 'Priority',
      visibility_duration: 'Visibility Duration',
      tenant: 'Tenant',
      actions: 'Actions',
      create: 'Create Category',
      edit: 'Edit Category',
      delete: 'Delete Category',
      refresh: 'Refresh',
      search: 'Search...',
      hours: 'hours',
      days: 'days',
      select_tenant: 'Select Tenant',
      tenant_required: 'Tenant is required',
      name_required: 'Name is required',
      type_required: 'Type is required',
      level_required: 'Level is required',
      create_success: 'Category created successfully',
      create_error: 'Error creating category',
      update_success: 'Category updated successfully',
      update_error: 'Error updating category',
      delete_success: 'Category deleted successfully',
      delete_error: 'Error deleting category',
      delete_conflict_error: 'This category is still in use and cannot be deleted. Please remove all assigned items first to delete the category.',
      load_error: 'Error loading categories',
      delete_confirm_title: 'Delete Category',
      delete_confirm_content_with_reports: 'Are you sure you want to delete this category? Deleting this category will delete {count} assigned reports with it! This action cannot be undone.',
      delete_confirm_content_no_reports: 'Are you sure you want to delete this category? There are no reports assigned to this category. This action cannot be undone.'
    },
    new_report: {
      add_customer: 'Add customer',
      subject: 'Subject',
      select_type: 'Select category',
      send_report: 'Send',
      patch_report: 'Update',
      delete_report: 'Delete',
      delete_dialog_text: 'Do you really want to delete the report?',
      subject_required: 'Enter a subject!',
      content_required: 'Enter the content of the report!',
      update_required: 'Enter the content of the update!',
      category_required: 'Select a category!',
      customer_required: 'Select a customer!',
      start_point_of_time: 'Start time',
      end_point_of_time: 'End time',
      time_range_required: 'Please specify a maintenance period',
      time_range_duration_too_small: 'Please select a period longer than 15 minutes',
      report_created: 'Report created',
      report_last_updated: 'Last update',
      report_creator: 'Creator'
    },
    notification: {
      report_created_successfull: 'Success',
      report_created_successfull_text: 'The report was successfully sent!',
      report_patched_successfull: 'Success',
      report_patched_successfull_text: 'The report was successfully updated!',
      report_update_created_successfull: 'Success',
      report_update_created_successfull_text: 'The update was successfully sent!',
      report_update_patched_successfull: 'Success',
      report_update_patched_successfull_text: 'The update was successfully updated!',
      login_error: 'Error',
      login_error_text: 'The username or password entered is incorrect!',
      login_error_not_admin_text: 'ADMIN rights are required to log in to this system!',
      mobil_alert: 'This screen size is not supported!'
    },
    settings: {
      synchronizedAccounts: 'Synchronized accounts',
      adConnectionAdded: 'Connection added successfully',
      adConnectionDeleted: 'Connection deleted successfully',
      adConnectionUpdated: 'Connection updated successfully',
      adConnectionCount: 'Connections count',
      addConnection: 'Add Connection',
      noConnections: 'No connections available',
      ldapSubtitle: 'LDAP / Active Directory connections',
      addLdapServer: 'Add LDAP Server',
      adColServer: 'Server',
      adColLoginDomain: 'Login-Domain',
      adColSynchronized: 'Synchronized',
      adColActive: 'Active',
      connectionsSingular: 'connection',
      connectionsPlural: 'connections',
      selectServer: 'Select server',
      connectionDialogSubtitle: 'Link an LDAP source to this customer',
      dnPlaceholder: 'OU=Department,DC=domain,DC=com',
      ldapEmptyTitle: 'No LDAP connection yet',
      ldapEmptySubtitle: 'Link a directory service to automatically synchronize this customer\'s accounts.',
      sectionEntra: 'Entra settings',
      noEntraConnections: 'No Entra connections available',
      entraEmptyTitle: 'No Entra provider yet',
      entraEmptySubtitle: 'Link an Entra group to automatically synchronize this customer\'s accounts.',
      entraGroup: 'Group',
      selectConnection: 'Select connection',
      selectGroup: 'Select group',
      entraGroupSelectFirst: 'Select a connection first',
      entraConnectionCreate: 'Create connection',
      entraConnectionEdit: 'Edit connection',
      entraProviderDialogSubtitle: 'Link an Entra source to this customer',
      entraConnectionAdded: 'Connection added successfully',
      entraConnectionUpdated: 'Connection updated successfully',
      entraConnectionDeleted: 'Connection deleted successfully',
      entraDeleteConnectionTitle: 'Delete connection',
      entraDeleteProviderInfoText: 'Are you sure you want to delete this Entra provider?',
      addEntraConnection: 'Add Entra tenant',
      entraName: 'Name',
      entraNamePlaceholder: 'Name of the connection',
      entraTenantId: 'Entra Tenant ID',
      entraTenantNameColumn: 'Entra Tenant Name',
      entraTenantColumn: 'Entra Tenant',
      entraTenantIdHint: 'The tenant ID from the customer\'s Entra portal',
      entraConsentUrlLabel: 'Admin consent URL',
      entraConsentUrlLoading: 'Loading consent URL…',
      entraConnectionCreateSubtitle: 'Create a new connection to an Entra tenant',
      entraConnectionEditSubtitle: 'Edit the connection to the Entra tenant',
      entraRegistrationTitle: 'App registration',
      entraRegistrationSubtitle: 'The Microsoft Entra app registration',
      entraRegistrationUpdated: 'App registration updated successfully',
      servers: 'Servers',
      entraAppId: 'App ID',
      entraClientSecret: 'Client Secret',
      entraServerAdd: 'Add Entra tenant',
      entraServerEdit: 'Edit Entra tenant',
      editLdapServerConnection: 'Edit LDAP server connection',
      entraGroupSync: 'Synchronize groups',
      entraGroupSyncSuccess: 'Groups synchronized successfully',
      entraGroupSyncSuccessCount: '{count} groups synchronized successfully',
      entraGroupSyncError: 'The groups could not be synchronized.',
      entraErrors: {
        connectionAlreadyExists: 'A connection for this Entra tenant already exists.',
        providerAlreadyExists: 'A provider with this connection and group already exists for this customer.',
        registrationMissing: 'No app registration configured. Please save the App ID and Client Secret first.',
        connectionFailed: 'Could not connect to Microsoft Entra. Please check the app registration and tenant ID.',
        validationFailed: 'The Entra provider could not be validated. Please check the connection and group.',
        notFound: 'The connection or group could not be found. Please synchronize the groups.',
        forbidden: 'You do not have permission to perform this action.',
        generic: 'An unexpected error occurred. Please try again.'
      },
      changeWarning: {
        title: 'Warning!',
        confirm: 'Yes, apply change',
        text: 'This change affects {providers} and {accounts}. It may cause problems during the next synchronization. Are you sure you want to apply this change?',
        providersSingular: '1 linked customer',
        providersPlural: '{count} linked customers',
        accountsSingular: '1 synchronized account',
        accountsPlural: '{count} synchronized accounts'
      },
      entraRules: {
        connection: 'Please select a connection',
        group: 'Please select a group',
        appId: 'Please enter the App ID',
        clientSecret: 'Please enter the Client Secret',
        tenantId: 'Please enter the Entra Tenant ID',
        name: 'Please enter a name'
      },
      roleDescriptions: {
        USER: 'View reports',
        REPORTER: 'Create reports',
        ADMIN: 'Full access'
      },
      entries: 'entries',
      emailSentTo: 'Email sent to {name}',
      pushSentTo: 'Push sent to {name}',
      accountStatusChangeError: 'Error changing account status',
      editTenant: 'Edit Tenant',
      selfTenantSettings: 'Tenant Settings',

      logo_upload_type_error: 'Please upload image files only',
      logo_upload_size_error: 'Image size cannot exceed 2MB',
      logo_upload_success: 'Logo uploaded successfully',
      logo_upload_error: 'Error uploading logo, please try again',
      logo_preview: 'Logo preview',
      logo_remove: 'Remove logo',
      logo_upload: 'Upload logo',
      logo_drag: 'Drag logo here or click to upload',

      accountRules: {
        firstName: 'Please enter first name',
        lastName: 'Please enter last name',
        email: 'Please enter email',
        appLoginName: 'Please enter login name',
        loginDomain: 'Please enter login domain',
        noSpecialChars: 'Special characters not allowed',
      },
      customerRules: {
        name: 'Please enter name',
        email: 'Please enter email',
        appLoginName: 'Please enter domain during login',
        user: 'The LDAP user must be specified',
        password: 'The LDAP password must be specified',
        url: 'The LDAP URL must be specified',
        role: 'Please select a role'
      },
      nameRequired: 'Name is required',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      emailRequired: 'Email is required',
      invalidEmail: 'Invalid email address',
      appLoginNameRequired: 'Login name is required',
      adConnections: {
        create: 'Create connection',
        edit: 'Edit connection',
        createSubtitle: 'Connect a new LDAP server',
        editSubtitle: 'Adjust the LDAP server connection',
        serverHint: 'Secure connection over LDAPS recommended (port 636).',
        passwordEditHint: 'Click to change — the old password will be discarded.',
        newPasswordPlaceholder: 'Enter new password',
        testConnection: 'Test connection',
        deleteConnectionTitle: 'Delete connection',
        deleteConnectionInfoText: 'Are you sure you want to delete the connection? {synced} users are synchronized.',
        validationSuccess: 'Connection tested successfully.',
        ldapServerErrors: {
          alreadyExists: 'A connection for this LDAP server already exists.',
          connectionFailed: 'Could not connect to the LDAP server. Please check the URL, domain and credentials.',
          noMatchingUser: 'No matching user found in the directory.',
          generic: 'An unexpected error occurred. Please try again.'
        }
      },
      // Tenant Management
      tenantCreate: 'Create Tenant',
      tenantCreated: 'Tenant successfully created',
      tenantSection: 'Tenant Information',
      addressSection: 'Address Information',
      contactSection: 'Contact Information',
      editAccount: 'Edit Account',
      // Basic tenant info
      description: 'Description',
      logo: 'Logo URL',

      // Address fields
      address: {
        street: 'Street',
        zipCode: 'Zip Code',
        city: 'City',
        country: 'Country',
        state: 'State'
      },

      // Contact fields
      contact: {
        name: 'Contact Person',
        email: 'Email',
        phone: 'Phone',
        fax: 'Fax',
        website: 'Website'
      },
      showTenantAccounts: 'Show Accounts',
      showTenantCustomers: 'Show Customers',
      tenantAccounts: 'Tenant Accounts',
      tenantCustomers: 'Tenant Customers',
      tenantsTableEmpty: 'No tenants found',
      createAccount: 'Create Account',
      accountCreated: 'Account successfully created',
      accountCreateError: 'An error occurred while saving the user',
      accountsTableEmpty: 'No accounts found',
      createCustomer: 'Create Customer',
      customerCreated: 'Customer successfully created',
      customersTableEmpty: 'No customers found',
      tenant: {
        name: 'Tenant',
        search: 'Search tenants',
        customerCount: 'Accounts count',
        accountCount: 'Customers count',
        activated: 'Tenant activated',
        deactivated: 'Tenant deactivated',
      },
      tenantManagement: 'Tenant Management',
      refresh: 'Refresh',
      deleteTenant: 'Delete Tenant',
      deleteTenantConfirm: 'Confirm Delete Tenant',
      deleteTenantWarning: 'Are you sure you want to delete this tenant and all associated data? This action cannot be undone.',
      tenantDeleted: 'Tenant successfully deleted',
      tenantDeleteFailed: 'Failed to delete tenant',
      backToTenants: 'Back to Tenants',
      backToCustomers: 'Back to Customers',
      active: 'Active',

      searchHint: "Search by name, domain, email",
      dateTimeFormat: "MM/DD/YYYY · h:mm A",
      searchAccountHint: "Search by first name, last name, email, role, login name",

      account: {
        inactive: 'inactive',
        delete: 'Delete account',
        search: 'Search accounts',
        sendEmail: 'Send email',
        sendPush: 'Send push notification',
        resetPushToken: 'Delete device token',
        activated: 'Account activated',
        deactivated: 'Account deactivated',
        sendTestEmail: 'Send Test Email',
        sendTestPush: 'Send Test Push',
        resetAllTokens: 'Reset All Tokens',
        currentUser: "Current User",
        noActionsPossible: "No actions possible",
        type: 'Type',
        local: 'Local',
        ldap: 'Ldap',
        typeFilter: 'Filter by account type',
        ldapAccounts: 'Ldap accounts',
        remoteAccounts: 'Remote accounts',
        localAccounts: 'Local accounts',
      },
      status: 'Status',

      customer: {
        search: 'Search customers',
        assign: 'Assign Customer',
        selectToAssign: 'Select customer to assign',
        assignButton: 'Assign',
        assigned: 'Assigned Customers',
        assignSuccess: 'Customer successfully assigned',
        removedFromAccount: 'Customer removed from account',
        name: 'Customers',
        required: 'Customer required'
      },

      customerName: 'Customer',

      // Global Overview
      globalOverview: 'Global Overview',
      globalCustomers: 'All Customers',
      globalAccounts: 'All Accounts',
      globalTenants: 'All Tenants',
      tenantEdit: 'Edit Tenant',
      tenants: 'Tenants',
      customers: 'Customers',
      accounts: 'Accounts',
      viewAll: 'View All',
      recentTenants: 'Recent Tenants',
      recentCustomers: 'Recent Customers',
      tenantName: 'Tenant',
      view: 'View',
      backToDashboard: 'Back to Dashboard',
      backToAccounts: 'Back to Accounts',
      createGlobalAccount: 'Create Global Account',
      accountSection: 'Account Information',
      accessSection: 'Access & Assignment',
      selectTenant: 'Select Tenant',
      selectCustomer: 'Select Customer',
      accountActions: 'Account Actions',
      editCustomer: 'Edit Customer',

      // Test and Status Messages
      testEmailSent: 'Test email sent',
      testEmailFailed: 'Failed to send test email',
      testPushSent: 'Test push notification sent',
      testPushFailed: 'Failed to send test push notification',
      pushTokensReset: 'Push tokens reset',
      pushTokensResetFailed: 'Failed to reset push tokens',
      accountUpdated: 'Account successfully updated',
      accountDeleted: 'Account successfully deleted',

      // General Settings
      accountSectionINFO: 'Account Settings',
      sectionINFO: 'General Settings',
      sectionLDAP: 'LDAP Settings',
      otherCustomer: 'Other Customers',
      overview: 'Overview',
      ldapTableEmpty: "No data available",
      name: 'Name',
      appLoginDomain: 'Login domain for local accounts',
      base: 'Users (DN)',
      adminBase: 'Admins (DN)',
      reporterBase: 'Reporters (DN)',
      lastSynchronized: 'Last synchronization',
      lastSynchronizedTry: 'Last synchronization attempt',
      nextSynchronizeTry: 'Next synchronization attempt',
      url: 'Server',
      user: 'User',
      domainLogin: 'Login domain',
      ldapAccounts: 'LDAP Accounts',
      localAccounts: 'Local Accounts',
      userCount: 'Synchronized accounts',
      localUserCount: 'Local accounts',
      usersWithTokenCount: 'Active accounts',
      operations: 'Options',
      authority: 'User permission',
      edit: 'Edit',
      mail_reception: 'Email reception',
      mail: 'Email distributor',
      password: 'Password',
      save: 'Save',
      create: 'Create',
      customerCreate: 'Add customer',
      customerAccounts: 'Accounts',
      syncCustomerAccounts: 'Synchronize accounts',
      showCustomerAccounts: 'Show accounts',
      showCustomerAccountsError: 'was not synchronized.',
      showCustomerAccountsSuccess: 'synchronized.',
      createLocalAccount: 'Create local account',
      deleteCustomer: 'Delete Customer',
      deleteCustomerInfoText: 'The customer and all synchronized accounts will be permanently deleted.',
      deleteAccount: 'Delete Account',
      deleteAccountInfoText: 'The account will be irrevocably deleted. Are you sure?',
      customerDeleted: 'Customer deleted',
      patchSuccess: 'Save successful',
      genericHttpError: 'An error occurred while saving, check your inputs and try again.',
      customerExists: 'A customer with the specified parameters already exists',
      defaultCustomer: 'Preselected recipient',
      uniqueCode: 'Unique Code',
      createdAt: 'Created At',
      updatedAt: 'Updated At',

      logDialog: {
        logButtonTooltip: 'Show server logs',
        dialogTitle: 'Server Logs',
        refreshButton: 'Refresh logs',
        automaticIndicator: 'Automatic scrolling',
        emptyState: 'No logs available'
      },
      report_sort: {
        sort_title: 'Sort by',
        TYPE_DATE: 'Report type',
        CREATED_DATE: 'Creation',
        UPDATE_DATE: 'Update',
        START_DATE: 'Start date'
      },
      notificationSettings: {
        notificationTitle: 'Notifications',
        NONE: 'None',
        ONLY_DISORDER: 'Only disruptions',
        ALL: 'All'
      }
    }
  }
}
